// noinspection ExceptionCaughtLocallyJS,JSUnusedAssignment

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getIncidents,
  addIncident,
  updateIncident,
  ApiIncidentManageFilters,
  getIncidentById,
  archiveIncident,
} from 'services/incidentsEndPoints';
import { IncidentsInterface, IIncident } from 'interfaces/incident.interface';
import apiFetch from 'services/apiFetch';
import { RootState } from '../../index';

export const fetchIncidents = createAsyncThunk(
  'incidents/fetchAllincidents',
  async (filters: ApiIncidentManageFilters) => {
    try {
      const endpoint = getIncidents(filters);
      const response = await apiFetch<IncidentsInterface>(endpoint).then(
        (res) => res?.data || null,
      );
      if (response) {
        const pageCount = response.last_page;
        return {
          incidents: response.data,
          pageTotal: pageCount,
        };
      } else {
        throw Error('No data found!');
      }
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else message = String(error);
      console.log('fetchUsersList catch:', error);
      throw Error(message);
    }
  },
);

export const createIncident = createAsyncThunk(
  'incidents/createIncident',
  async (data: IIncident, { getState }) => {
    try {
      const { token } = getState() as RootState;
      const user = token.user;
      const payload: IIncident = {
        name: data.name,
        status: data.status || 0,
        description: data.description,
        deleted: 0,
        archived: 0,
        date: data.date,
        userId: user?.id,
      };
      const endpoint = addIncident(payload);
      const response = apiFetch(endpoint).then((res) => res?.data || null);
      if (response) {
        return response;
      } else {
        throw Error('Internal Server Error');
      }
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else message = String(error);
      console.log('createIncident catch:', error);
      throw Error(message);
    }
  },
);

export const updateSelectedIncident = createAsyncThunk(
  'incidents/updateIncident',
  async (payload: { data: IIncident; id: string }, { getState }) => {
    try {
      const { token } = getState() as RootState;
      const user = token.user;
      payload.data.userId = user?.id;
      const endpoint = updateIncident(payload.data, payload.id);
      const response = await apiFetch<{ data: IIncident }>(endpoint).then(
        (res) => res?.data || null,
      );

      if (response) {
        return response;
      }

      // return params;
    } catch (error) {
      console.log('updateIncident catch:', error);
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else message = String(error);
      throw Error(message);
    }
  },
);

export const archiveIncidentById = createAsyncThunk(
  'incidents/archiveIncident',
  async (id: string) => {
    try {
      const endpoint = archiveIncident({ id: id });
      return await apiFetch<{ message: string }>(endpoint).then((res) => res?.data || null);
    } catch (error) {
      console.log('archiveIncident catch:', error);
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else message = String(error);
      throw Error(message);
    }
  },
);
